module.exports = __webpack_public_path__ + "static/media/select_white.f88e6b56.svg";